import React, { useContext, useEffect, useState } from "react";
import * as S from "./SaquesStyle";
import ModalNovoSaque from "./ModalNovoSaque";
import { formatNumber, formatDate } from "../ASSETS/assets";
import Loading from "../Loader";
import { AuthContext } from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import { FaPlus, FaSearch, FaTimes, FaFileInvoiceDollar } from "react-icons/fa";
import { useMessage } from "../../Context/MessageContext";
import { withdrawAdminService } from "../../Services/withdrawAdminService";
import { auditService } from "../../Services/auditService";
import ModalCreateReceipt from "./ModalCreateReceipt";

export default function Saques() {
  const { withdrawals, totalWithdrawals, getSaques, authState } =
    useContext(AuthContext);
  const [search, setSearch] = useState("");
  const [contractSearch, setContractSearch] = useState("");
  const [modalNovoSaque, setModalNovoSaque] = useState(false);
  const [load, setLoad] = useState(false);
  const [sortOrder, setSortOrder] = useState("desc");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [modalConta, setModalConta] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const navigate = useNavigate();
  const { showMessage } = useMessage();
  const [modalReceiptData, setModalReceiptData] = useState(null);
  const totalPages = Math.ceil(totalWithdrawals / itemsPerPage);

  const fetchSaques = async (page) => {
    setLoad(true);
    const offset = (page - 1) * itemsPerPage;
    try {
      await getSaques(
        itemsPerPage,
        offset,
        sortOrder,
        1,
        search,
        startDate,
        endDate,
        contractSearch
      );
    } catch (e) {
      console.log(e);
    }
    setLoad(false);
  };

  useEffect(() => {
    if (
      authState.permission &&
      authState.permission !== "ALL" &&
      !authState.permission.includes("CRIAR/EDITAR/AUTORIZAR SAQUES")
    ) {
      navigate("/");
    }
  }, [authState.permission, navigate]);

  useEffect(() => {
    fetchSaques(currentPage);
  }, [currentPage, sortOrder, startDate, endDate]);

  const handleSearch = () => {
    setCurrentPage(1);
    fetchSaques(1);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleStatus = (status) => {
    switch (status) {
      case 1:
        return "Pendente";
      case 2:
        return "Pago";
      case 3:
        return "Cancelado";
      case 4:
        return "Ctr. Recomprado";
      default:
        return "Indefinido";
    }
  };

  const handleChangeStatus = async (id, clientName, newStatus) => {
    setLoad(true);
    try {
      await withdrawAdminService.updateWithdrawStatus(id, newStatus);
      fetchSaques(currentPage);
      showMessage("Transação feita com sucesso.", "success");
      await auditService.registerWithdrawalApproval(
        id,
        clientName,
        newStatus === 2 || newStatus === "2"
      );
    } catch (error) {
      console.log(error);
      showMessage("Erro ao realizar transação.", "error");
    } finally {
      setLoad(false);
    }
  };

  const openInNewTab = (url) => {
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <>
      <S.SaquesContainer>
        {modalConta && (
          <S.ModalConta>
            <div className="box">
              <button onClick={() => setModalConta(null)} className="close">
                <FaTimes />
              </button>
              <h3 className="title">Dados Bancários</h3>
              <div className="account">
                <div className="boxzinha">
                  <strong>Cliente:</strong> {modalConta.clientName}
                </div>
                <div className="boxzinha">
                  <strong>Banco:</strong>{" "}
                  {modalConta.clientBankAccount?.bank || "Não informado"}
                </div>
                <div className="boxzinha">
                  <strong>Agência:</strong>{" "}
                  {modalConta.clientBankAccount?.agencyNumber ||
                    "Não informado"}
                </div>
                <div className="boxzinha">
                  <strong>Conta:</strong>{" "}
                  {modalConta.clientBankAccount?.accountNumber ||
                    "Não informado"}
                </div>
                <div className="boxzinha">
                  <strong>Tipo:</strong>{" "}
                  {modalConta.clientBankAccount?.accountType || "Não informado"}
                </div>
                <div className="boxzinha">
                  <strong>PIX:</strong>{" "}
                  {modalConta.clientBankAccount?.pixKey || "Não informado"}
                </div>
              </div>
            </div>
          </S.ModalConta>
        )}
        {modalNovoSaque && (
          <ModalNovoSaque
            setModalNovoSaque={setModalNovoSaque}
            fetchSaques={() => fetchSaques(1)}
          />
        )}
        <Loading load={load} />

        <S.ContentBox>
          <S.SaquesFirstContent>
            <S.AreaTitle>Validar Saques</S.AreaTitle>
            <S.AddSaques onClick={() => setModalNovoSaque(true)}>
              <FaPlus /> Realizar Novo Saque
            </S.AddSaques>
          </S.SaquesFirstContent>

          <S.Filtros>
            <S.SearchBar>
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                type="text"
                placeholder="Pesquisar cliente ou CPF..."
              />
              <button onClick={handleSearch}>
                <FaSearch />
              </button>
            </S.SearchBar>
            <S.FiltroStatus>
              <div className="box">
                <span className="title">ID Contrato</span>
                <input
                  type="number"
                  placeholder="ID..."
                  value={contractSearch}
                  onChange={(e) => setContractSearch(e.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                  className="selectBox"
                />
              </div>
              <div className="box">
                <span className="title">Início</span>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="selectBox"
                />
              </div>
              <div className="box">
                <span className="title">Fim</span>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="selectBox"
                />
              </div>
              <div className="box">
                <span className="title">Ordem</span>
                <select
                  value={sortOrder}
                  onChange={(e) => setSortOrder(e.target.value)}
                  className="selectBox"
                >
                  <option value="desc">Mais Recentes</option>
                  <option value="asc">Mais Antigos</option>
                </select>
              </div>
            </S.FiltroStatus>
          </S.Filtros>

          <S.TableContainer>
            <S.Table>
              <S.TableHeader>
                <S.TableRow>
                  <S.TableHeaderCell>ID</S.TableHeaderCell>
                  <S.TableHeaderCell>Cliente</S.TableHeaderCell>
                  <S.TableHeaderCell>Data</S.TableHeaderCell>
                  <S.TableHeaderCell>Valor</S.TableHeaderCell>
                  <S.TableHeaderCell>Valor a Pagar</S.TableHeaderCell>
                  <S.TableHeaderCell>
                    Fundos (Contrato/Indicação)
                  </S.TableHeaderCell>
                  <S.TableHeaderCell>
                    Reversão para Ctr
                  </S.TableHeaderCell>
                  <S.TableHeaderCell>Conta</S.TableHeaderCell>
                  <S.TableHeaderCell>Status</S.TableHeaderCell>
                  <S.TableHeaderCell>Opções</S.TableHeaderCell>
                  <S.TableHeaderCell>Recibo</S.TableHeaderCell>
                </S.TableRow>
              </S.TableHeader>
              <S.TableBody>
                {withdrawals.map((user) => (
                  <S.TableRow key={user.withdraw.id}>
                    <S.TableCell>{user.withdraw.id}</S.TableCell>
                    <S.TableCell>{user.clientName}</S.TableCell>
                    <S.TableCell>
                      {formatDate(user.withdraw.dateCreated)}
                    </S.TableCell>
                    <S.TableCell>
                      R$ {formatNumber(user.withdraw.amountWithdrawn || 0)}
                    </S.TableCell>
                    <S.TableCell>
                      R$ {formatNumber(user.withdraw.amountReceivable || 0)}
                    </S.TableCell>
                    <S.TableCell>
                      {user.withdraw.contractId
                        ? "#" + user.withdraw.contractId
                        : "Saque De Indicação"}
                    </S.TableCell>
                    <S.TableCell>
                      {user.withdraw.forContractBuyingId
                        ? "#" + user.withdraw.forContractBuyingId
                        : "Saque Normal"}
                    </S.TableCell>
                    <S.TableCell>
                      <S.ActionButton onClick={() => setModalConta(user)}>
                        Ver Conta
                      </S.ActionButton>
                    </S.TableCell>
                    <S.TableCell>
                      {handleStatus(user.withdraw.status)}
                    </S.TableCell>
                    <S.TableCell>
                      <S.OptionsButtons>
                        <button
                          style={{ background: "#c0392b" }}
                          onClick={() =>
                            handleChangeStatus(
                              user.withdraw.id,
                              user.clientName,
                              3
                            )
                          }
                        >
                          Cancelar
                        </button>
                        <button
                          style={{ background: "#27ae60" }}
                          onClick={() =>
                            handleChangeStatus(
                              user.withdraw.id,
                              user.clientName,
                              2
                            )
                          }
                        >
                          Pagar
                        </button>
                      </S.OptionsButtons>
                    </S.TableCell>
                    <S.TableCell>
                      {user.withdraw.receiptUrl ? (
                        <>
                          <S.ActionButton
                            onClick={() =>
                              openInNewTab(user.withdraw.receiptUrl)
                            }
                            title="Ver Recibo"
                          >
                            <FaFileInvoiceDollar style={{ marginRight: 5 }} />{" "}
                            Ver Recibo
                          </S.ActionButton>
                        </>
                      ) : (
                        <S.ActionButton
                          onClick={() => setModalReceiptData(user)}
                          title="Anexar Recibo"
                        >
                          <FaFileInvoiceDollar style={{ marginRight: 5 }} />{" "}
                          Anexar
                        </S.ActionButton>
                      )}
                    </S.TableCell>
                  </S.TableRow>
                ))}
              </S.TableBody>
            </S.Table>
          </S.TableContainer>

          <S.PaginationContainer>
            <S.PaginationButton
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Anterior
            </S.PaginationButton>
            <span>
              Exibindo{" "}
              {Math.min((currentPage - 1) * itemsPerPage + 1, totalWithdrawals)}{" "}
              a {Math.min(currentPage * itemsPerPage, totalWithdrawals)} de{" "}
              {totalWithdrawals}
            </span>
            <S.PaginationButton
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage >= totalPages}
            >
              Próxima
            </S.PaginationButton>
          </S.PaginationContainer>
        </S.ContentBox>
      </S.SaquesContainer>

      {modalReceiptData && (
        <ModalCreateReceipt
          withdrawData={modalReceiptData}
          onClose={() => {
            setModalReceiptData(null);
            fetchSaques(currentPage);
          }}
        />
      )}
    </>
  );
}
